<template>
	<div class="hand">
		<transition-group name="cards" class="cards" :data-count="hand.length" appear>
			<div v-for="card in hand" :key="card.id" class="card-wrap" :class="card.animation">
				<div class="card-wrap-content" v-draggable="card" @mouseenter="card_hover()">
					<card :card="card" />
				</div>
			</div>
		</transition-group>

		<ui-button class="reroll-button" :inactive="game.hero.gold < hand_reroll_price" :class="{ expansive: game.hero.gold < hand_reroll_price }" v-hammer:tap="reroll">
			<div class="text">Reroll</div>
			<ui-gold :value="hand_reroll_price" />
		</ui-button>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiGold from '@/components/ui/ui-gold'
import UiButton from '@/components/ui/ui-button'
import Card from '@/components/global/card'
import interact from 'interactjs'
import Sounds from '@/js/sounds'

let x = 0
let y = -112

export default {
	name: 'hand',
	computed: {
		...mapGetters([ 'game', 'hand_reroll_price' ]),
		hand() {
			return this.game.hand
		}
	},
	methods: {
		reroll() {
			this.$store.dispatch('reroll_hand')
		},
		card_hover() {
			Sounds.play('card-hover')
		}
	},
	directives: {
		draggable: {
			inserted($el, binding, vnode) {
				const card = binding.value
				const store = vnode.context.$store
				interact($el).styleCursor(false).draggable({
					onstart() {
						x = 0
						y = -112
						$el.classList.add('dragging', 'moving')
						store.commit('EDIT_GAME_STATE', { dragging: card })
						Sounds.play('card-select')
					},
					onmove(event) {
						x += event.dx / store.getters.app.zoom
						y += event.dy / store.getters.app.zoom
						$el.style.transform = 'translate(' + x + 'px, ' + y + 'px)'
					},
					onend(event) {

						$el.classList.remove('dragging')
						setTimeout(() => {
							$el.classList.remove('moving')
						})

						if (event.dropzone && event.dropzone.target.classList.contains('allow')) {
							Sounds.play('card-drop')
							$el.classList.add('dropping')
							const drop_rect = event.dropzone.getRect()
							const delta = { x: event.rect.left - drop_rect.left, y: event.rect.top - drop_rect.top }
							const new_value = { x: x - delta.x - (event.rect.width / 2 - drop_rect.width / 2), y: y - delta.y }
							// $el.style.transform = 'translate(' + new_value.x + 'px, ' + new_value.y + 'px) scale(1)'

							store.commit('EDIT_GAME_OBJ', { obj: card, animation: 'playing' })
							// $el.style.transitionDuration = '0.25s'
							$el.style.transform = 'translate(' + new_value.x + 'px, ' + new_value.y + 'px) scale(0.85)'
							$el.style.opacity = 0
							store.dispatch('play_card', { card, position: parseInt(event.dropzone.target.dataset.position) })
						} else {
							$el.style.transform = ''
							Sounds.play('card-hover')
						}
						store.commit('EDIT_GAME_STATE', { dragging: null })
					}
				})
			}
		}
	},
	components: { UiGold, UiButton, Card }
}
</script>

<style lang="stylus" scoped>

.hand
	position absolute
	left 0
	right 0
	bottom -96px
	width 100%
	height card_height / 2
	// background-color red
	flex center center
	.cards
		height 100%
		flex flex-end center 
		padding 0 32px
		
		&[data-count="3"] .card-wrap
			&:nth-child(1) .card-wrap-content
				transform scale(0.6) rotate(-5deg) translateY(8px)
			&:nth-child(2) .card-wrap-content
				transform scale(0.6) rotate(0)
			&:nth-child(3) .card-wrap-content
				transform scale(0.6) rotate(5deg) translateY(8px)
		
		&[data-count="4"] .card-wrap
			&:nth-child(1) .card-wrap-content
				transform scale(0.6) rotate(-8deg) translateY(32px)
			&:nth-child(2) .card-wrap-content
				transform scale(0.6) rotate(-2deg) translateY(8px)
			&:nth-child(3) .card-wrap-content
				transform scale(0.6) rotate(2deg) translateY(8px)
			&:nth-child(4) .card-wrap-content
				transform scale(0.6) rotate(8deg) translateY(32px)
				
		&[data-count="5"] .card-wrap
			&:nth-child(1) .card-wrap-content
				transform scale(0.6) rotate(-10deg) translateY(32px)
			&:nth-child(2) .card-wrap-content
				transform scale(0.6) rotate(-5deg) translateY(8px)
			&:nth-child(3) .card-wrap-content
				transform scale(0.6) rotate(0deg)
			&:nth-child(4) .card-wrap-content
				transform scale(0.6) rotate(5deg) translateY(8px)
			&:nth-child(5) .card-wrap-content
				transform scale(0.6) rotate(10deg) translateY(32px)
				
		&[data-count="6"] .card-wrap
			&:nth-child(1) .card-wrap-content
				transform scale(0.6) rotate(-10deg) translateY(32px)
			&:nth-child(2) .card-wrap-content
				transform scale(0.6) rotate(-5deg) translateY(12px)
			&:nth-child(3) .card-wrap-content
				transform scale(0.6) rotate(-2deg) translateY(4px)
			&:nth-child(4) .card-wrap-content
				transform scale(0.6) rotate(2deg) translateY(4px)
			&:nth-child(5) .card-wrap-content
				transform scale(0.6) rotate(5deg) translateY(12px)
			&:nth-child(6) .card-wrap-content
				transform scale(0.6) rotate(10deg) translateY(32px)
				
		&[data-count]
			.card-wrap
				margin 0 -56px
				pointer-events none
				// // transition 0.15s easeOutQuart
				// &.cards-leave-active
				// 	// transition transform 0.3s easeOutQuart, opacity 0.05s easeOutQuart
				// 	position absolute
				// &.cards-leave-to
				// 	opacity 0
				// 	transform translateY(240px)
				&.cards-enter
					opacity 0
					transform translateY(-150px)
				&.cards-enter-active
					transition 0.3s easeOutQuart
					&:nth-child(1)
						transition-delay 0.05s
					&:nth-child(2)
						transition-delay 0.1s
					&:nth-child(3)
						transition-delay 0.15s
					&:nth-child(4)
						transition-delay 0.2s
					&:nth-child(5)
						transition-delay 0.25s
					&:nth-child(6)
						transition-delay 0.3s
				&:before
					content ''
					position absolute
					left 0
					right 0
					top 100%
					height 64px
				.card-wrap-content
					transition 0.15s easeOutQuart
					transform scale(0.6)
					pointer-events all
					&:before
						content ''
						position absolute
						left 0
						right 0
						top 100%
						height 32px
					&:hover
						transform translateY(-112px) scale(1)
						z-index 2
					&.dragging
						transition none
					&.moving
						z-index 3
					&.dropping
						transition 0.25s easeOutQuart

	>>> .reroll-button
		position absolute
		left calc(50% + 380px)
		bottom (96px + 24px)
		transform scale(0.8)
		&.expansive
			color red
		.text
			margin 0 16px 0 0
		.ui-gold
			.icon
				margin-left 4px
		
		

</style>
